import { render } from "./OnboardingTutorial.vue?vue&type=template&id=3d3345e7&scoped=true"
import script from "./OnboardingTutorial.vue?vue&type=script&lang=js"
export * from "./OnboardingTutorial.vue?vue&type=script&lang=js"

import "./OnboardingTutorial.vue?vue&type=style&index=0&id=3d3345e7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d3345e7"]])

export default __exports__